import { Card, Grid, Typography, Tooltip } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { profileContent } from './ProfileContent';
import Spinner from '../../components/spinner/Spinner';
import Loader from '../../components/loader/Loader';

const Profile = () => {
    const [mobileView] = useOutletContext();
    const { candidateProfile } = useSelector((state) => state.candidateState);
    const profileInformation = {
        variant: 'subtitle2',
        color: 'text.secondary',
        textAlign: 'start',
        whiteSpace: 'pre-wrap',
    };
    return (
        <Card sx={{ mx: mobileView ? 4 : 8, my: 4, textAlign: 'center' }}>
            <Grid container p={1}>
                {candidateProfile
                    ? profileContent.map((content, index) => (
                          <Grid item xs={12} sm={6} md={4} key={index}>
                              <Grid container my={2}>
                                  <Grid item xs={4} m='auto' sx={{ maxWidth: '4% !important',mt:0.5}}>
                                      {content.contentIcon}
                                  </Grid>
                                  <Grid container item xs={8}>
                                      <Grid item xs={12}>
                                          <Typography {...profileInformation}>
                                              {content.contentLabel}
                                          </Typography>
                                      </Grid>
                                      <Grid item xs={12} textAlign='left'>
                                          {content?.contentType === 'link' ? (
                                              <Tooltip
                                                  title={
                                                      candidateProfile &&
                                                      candidateProfile[content.name]
                                                  }>
                                                  <Typography
                                                      component='a'
                                                      sx={{ color: 'black' }}
                                                      href={candidateProfile[content.name]}
                                                      target='_blank'
                                                      {...profileInformation}
                                                      noWrap={!mobileView}>
                                                      {candidateProfile[content.name] || '-'}
                                                  </Typography>
                                              </Tooltip>
                                          ) : content?.contentType === 'object' ? (
                                              <Tooltip
                                                  title={
                                                      candidateProfile[content.name]?.file_url || ''
                                                  }>
                                                  <Typography
                                                      component='a'
                                                      sx={{ color: 'black' }}
                                                      href={
                                                          candidateProfile[content.name]?.file_url
                                                      }
                                                      target='_blank'
                                                      {...profileInformation}
                                                      noWrap={!mobileView}>
                                                      {candidateProfile[content.name]?.file_name ||
                                                          '-'}
                                                  </Typography>
                                              </Tooltip>
                                          ) : (
                                              <Typography
                                                  {...profileInformation}
                                                  sx={{ color: 'black' }}>
                                                  {candidateProfile[content.name] || '-'}
                                              </Typography>
                                          )}
                                      </Grid>
                                  </Grid>
                              </Grid>
                          </Grid>
                      ))
                    : // <Loader />
                      ''}
            </Grid>
        </Card>
    );
};

export default Profile;
